<template>
  <div class="fillcontain" >
    <head-top></head-top>
    <div class="site-wrapper site-page--not-found">
      <div class="site-content__wrapper">
        <div class="site-content">
          <h2 class="not-found-title">抱歉！</h2>
          <p class="not-found-desc">您访问的页面<em>暂无内容</em></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import headTop from '../components/headTop'
  export default {
    components: {
      headTop,
    },
  }
</script>

<style lang="less">
  .site-wrapper.site-page--not-found {
    position: absolute;
    top: 60px;
    right: 0;
    bottom: 0;
    overflow: hidden;
    .site-content__wrapper {
      padding: 0;
      margin: 0;
      background-color: #fff;
    }
    .site-content {
      position: fixed;
      top: 15%;
      left: 50%;
      z-index: 2;
      padding: 30px;
      text-align: center;
      transform: translate(-50%, 0);
    }
    .not-found-title {
      margin: 80px auto 15px;
      font-size: 3em;
      font-weight: 500;
      color: rgb(55, 71, 79);
    }
    .not-found-desc {
      margin: 0 0 30px;
      font-size: 26px;
      text-transform: uppercase;
      color: rgb(118, 131, 143);
      > em {
        font-style: normal;
        color: #ee8145;
      }
    }
  }
</style>




// WEBPACK FOOTER //
// src/page/empty.vue